export default "__VITE_ASSET__BDewsTa3__"